document.addEventListener('teeinblue-event-component-injected', function() {

  const checkAndAddEventListener = () => {
    var button = document.querySelector('.teeinblue-platform-product-enabled .shopify-payment-button__button');
    if(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

          var shopifyPayButton = button.querySelector('[data-testid="ShopifyPay-button"]');
          if (shopifyPayButton) {
              shopifyPayButton.click();
          }
      });
      clearInterval(checkInterval);
    }
  }
  var checkInterval = setInterval(checkAndAddEventListener, 5000);
});